import Text from './Text';
import { Number } from './Number';
import InputProperties from './Properties';
export const FormattedInput = {
  Text,
  Number,
  InputProperties
};
